import SolelyTable from './solely-table/'
import SolelyCard from './solely-card/'
import SolelyContent from './solely-content/'
import {
  SlsInput,
  SlsTextarea,
  SlsSelect,
  upload,
  VueEditor,
  SlsCheckbox,
  SlsCascader,
  SlsDateTimeRange,
  BaiduMap,
  TinymceEditor,
  Rate,
  QiUpload,
  TencentMap,
  DbUpload,
  SlsDatePicker,
  SlsRadio,
  SlsTimePicker

 } from './solely-fields/index.js'


import solelyEcharts from './echarts/solely-echarts.vue'


export default{
  SolelyTable,
  SolelyContent,
  SlsInput,
  SlsTextarea,
  SlsSelect,
  upload,
  VueEditor,
  SlsCheckbox,
  SlsCascader,
  SlsDateTimeRange,
  BaiduMap,
  SolelyCard,
  TinymceEditor,
  solelyEcharts,
  Rate,
  TencentMap,
  DbUpload,
  SlsTimePicker,
  SlsRadio,
  SlsDatePicker
}



// WEBPACK FOOTER //
// ./src/components/index.js